module.exports = __webpack_public_path__ + "static/firstmedia_logo-dd1c4589abf9e493b5ce16b43cb1597b.png";